import axios from "axios";
import { Title } from "../models/responses/Title";
import { Profession } from "../models/responses/Profession";
import { Speciality } from "../models/responses/Speciality";
import { LegalLinks } from "../models/responses/LegalLinks";

const baseUrl = "/AutoConnectSSO/api/Shared/";

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

async function getTitles() {
  const response = await instance.get<Title>("Titres");
  return response.data;
}

async function getProfessions() {
  const instanceInter = axios.create({
    baseURL:
      "/AutoConnectSSO/api/Internal/Shared/Profession/Filtered/PhysicalPerson",
    withCredentials: true,
  });
  const response = await instanceInter.get<Profession>("");
  return response.data;
}
async function getSpecialities() {
  const response = await instance.get<Speciality>("Specialites");
  return response.data;
}

async function getLegalLinks() {
  const response = await instance.get<LegalLinks>("Legal/Links");
  return response.data;
}

export const SharedService = {
  getTitles,
  getProfessions,
  getSpecialities,
  getLegalLinks,
};
